﻿module.exports = {
    templateUrl: 'widgets/components/loading-indicator/loading-indicator-block.html'
};